import React from "react";

const STANDARDS = [
  { name: "AAOIFI", note: "Shariah standards", href: "https://aaoifi.com/" },
  { name: "IFSB", note: "Prudential guidance", href: "https://www.ifsb.org/" },
  { name: "Dow Jones Islamic Market", note: "Screening methodology", href: "https://www.spglobal.com/spdji/en/index-family/equity/shariah/" },
  { name: "S&P Shariah Indices", note: "Benchmark family", href: "https://www.spglobal.com/spdji/en/" },
  { name: "Yahoo Finance", note: "Company filings", href: "https://finance.yahoo.com/" },
  { name: "Tier-1 brokers", note: "Execution & custody" },
];

export const StandardsStrip = () => (
  <section className="bg-white border-y border-black/5" data-testid="standards-strip">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 py-10">
      <div className="text-center text-xs uppercase tracking-[0.2em] text-[#1A1330]/40">
        Screened, priced and settled on standards you can check
      </div>
      <div className="mt-7 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-x-6 gap-y-7">
        {STANDARDS.map((s) => {
          const Tag = s.href ? "a" : "div";
          return (
          <Tag key={s.name} {...(s.href ? { href: s.href, target: "_blank", rel: "noreferrer" } : {})}
            className="group text-center transition-opacity opacity-70 hover:opacity-100"
            data-testid={`standard-${s.name.split(" ")[0].toLowerCase()}`}>
            <div className="text-sm font-semibold tracking-tight text-[#1A1330] group-hover:text-[#3E2E65] transition-colors leading-snug">
              {s.name}
            </div>
            <div className="mt-1 text-[10px] uppercase tracking-[0.12em] text-[#1A1330]/40">{s.note}</div>
          </Tag>
          );
        })}
      </div>
    </div>
  </section>
);
